import { render } from "./DetailView.vue?vue&type=template&id=0cc369c8&scoped=true"
import script from "./DetailView.vue?vue&type=script&lang=ts"
export * from "./DetailView.vue?vue&type=script&lang=ts"

import "./DetailView.vue?vue&type=style&index=0&id=0cc369c8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0cc369c8"

export default script